/**
 * Wszystkie trasy API, których używa panel Planera — w jednym miejscu, żeby zgranie z backendem (NX-413) było jednym
 * plikiem. Trasy z kontraktu `@nexops/shared/planner/common.ts` + brakujące w nim odczyty/usunięcia nazwane jak w ZUR
 * (`/planner/attribute-defs`, `/planner/task-templates`, `GET|DELETE` zmian, czynności, nieobecności i wniosków).
 */
export const plannerRoutes = {
  team: '/planner/team',
  shifts: '/planner/shifts',
  shift: (id: string) => `/planner/shifts/${id}`,
  shiftsBulk: '/planner/shifts/bulk',
  tasks: '/planner/tasks',
  task: (id: string) => `/planner/tasks/${id}`,
  absences: '/planner/absences',
  absence: (id: string) => `/planner/absences/${id}`,
  requests: '/planner/requests',
  requestRespond: (id: string) => `/planner/requests/${id}/respond`,
  templates: '/planner/task-templates',
  template: (id: string) => `/planner/task-templates/${id}`,
  attributeDefs: '/planner/attribute-defs',
  attributeDef: (id: string) => `/planner/attribute-defs/${id}`,
  ruleset: '/planner/working-time/ruleset',
  /** Istniejące API Floty (lista pojazdów do wyboru na zmianie). */
  vehicles: '/fleet/vehicles',
} as const;

export const plannerKeys = {
  all: ['planner'] as const,
  team: () => [...plannerKeys.all, 'team'] as const,
  shifts: () => [...plannerKeys.all, 'shifts'] as const,
  shiftRange: (from: string, to: string) => [...plannerKeys.shifts(), from, to] as const,
  absences: () => [...plannerKeys.all, 'absences'] as const,
  absenceRange: (from: string, to: string) => [...plannerKeys.absences(), from, to] as const,
  requests: () => [...plannerKeys.all, 'requests'] as const,
  templates: () => [...plannerKeys.all, 'templates'] as const,
  attributeDefs: () => [...plannerKeys.all, 'attribute-defs'] as const,
  ruleset: () => [...plannerKeys.all, 'ruleset'] as const,
  vehicles: () => [...plannerKeys.all, 'vehicles'] as const,
};
